import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import GatewayShell from "../../../../../gateway/GatewayShell";
import GatewayAction from "../../../../../gateway/GatewayAction";
import GatewayStepProgress from "../../../../../gateway/GatewayStepProgress";
import GatewayField from "../../../../../gateway/GatewayField";

const Register = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formik = useFormik({
    initialValues: { firstName: "", lastName: "" },
    validationSchema: Yup.object({
      firstName: Yup.string().matches(/^[a-zA-Z'-]+$/, "Use letters only").min(2).max(25).required("Enter your first name"),
      lastName: Yup.string().matches(/^[a-zA-Z'-]+$/, "Use letters only").min(2).max(25).required("Enter your last name"),
    }),
    onSubmit: (values) => { localStorage.setItem("registerFirstScreen", JSON.stringify(values)); navigate("/personal-details"); },
  });
  return (
    <GatewayShell stage="registration" focused onBack={() => navigate({ pathname: "/login", search: location.search })}>
      <form className="gatewayCard" onSubmit={formik.handleSubmit} noValidate>
        <GatewayStepProgress current={1} total={8} />
        <h2>Create your Clikkle identity</h2>
        <p className="gatewayCard__sub">Tell us your name to begin.</p>
        <GatewayField label="First name" autoFocus autoComplete="given-name" name="firstName" placeholder="First name" value={formik.values.firstName} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.firstName ? formik.errors.firstName : ""} />
        <GatewayField label="Last name" autoComplete="family-name" name="lastName" placeholder="Last name" value={formik.values.lastName} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.lastName ? formik.errors.lastName : ""} />
        <GatewayAction type="submit">Continue</GatewayAction>
        <div className="gatewayActions gatewayActions--centered"><span>Already have an account?</span><Link to={{ pathname: "/login", search: location.search }}>Sign in</Link></div>
      </form>
    </GatewayShell>
  );
};
export default Register;
